export default __webpack_public_path__ + "static/media/YanoneKaffeesatz-Light.8cd60bcb.ttf";